import { render, staticRenderFns } from "./FilterUsersList.vue?vue&type=template&id=45d5fa40&scoped=true&"
import script from "./FilterUsersList.vue?vue&type=script&lang=js&"
export * from "./FilterUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5fa40",
  null
  
)

export default component.exports